export function getQuickEditSaveMode(role, changes = {}) {
  if (role !== "cashier") return "item";

  if (
    Object.prototype.hasOwnProperty.call(changes, "price") ||
    Object.prototype.hasOwnProperty.call(changes, "base_price")
  ) {
    return "forbidden";
  }

  return "stock";
}
